// Copyright ©️ 2026 eVolve MEP, LLC

import { Badge } from '@mantine/core';

/** Marks the `createdValue` of a creatable select. */
export const CreatedBadge = () => (
  <Badge variant="light-mantine" size="xs" flex="none" styles={{ label: { textOverflow: 'initial' } }}>
    NEW
  </Badge>
);
